export default "__VITE_PUBLIC_ASSET__d103dad6__"